"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KNOWN_ROLES = void 0;
const KNOWN_ROLES = {
  2: {
    id: 2,
    order: 0,
    isRequired: true,
    name: 'experimenter',
    displayName: 'Experimenter'
  },
  5: {
    id: 5,
    order: 1,
    isRequired: true,
    name: 'productOwner',
    displayName: 'Product Owner'
  },
  4: {
    id: 4,
    order: 2,
    isRequired: true,
    name: 'technicalContact',
    displayName: 'Technical Contact'
  },
  3: {
    id: 3,
    order: 3,
    isRequired: false,
    name: 'administrators',
    displayName: 'Administrators',
    allowMultipleUsers: true
  },
  6: {
    id: 6,
    order: 4,
    isRequired: true,
    displayName: 'Data Science Contact',
    allowMultipleUsers: false
  }
};
exports.KNOWN_ROLES = KNOWN_ROLES;